import Cookie from '~/shared/utils/Cookie';

const getToken = () => Cookie.get('token');

export default getToken;
